import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import TopNav from '../components/navigation_bar/TopNav';
import '../assets/css/notfound.css';

function NotFound() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const handlePrimaryAction = () => {
    if (isAuthenticated) {
      navigate('/dashboard');
    } else {
      navigate('/');
    }
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="notfound-page">
      <TopNav />

      {/* Main Not Found Hero */}
      <main className="notfound-main">
        <div className="notfound-card">
          <div className="notfound-code" aria-label="Error code 404">
            404
          </div>

          <p className="notfound-subtitle">Page not found.</p>

          {/* Action Buttons */}
          <div className="notfound-actions">
            <button
              type="button"
              className="notfound-btn notfound-btn-primary"
              onClick={handlePrimaryAction}
            >
              {isAuthenticated ? 'Go to Dashboard' : 'Return to Home'}
            </button>
            <button
              type="button"
              className="notfound-btn notfound-btn-secondary"
              onClick={handleGoBack}
            >
              Go Back
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default NotFound;
